import { render, staticRenderFns } from "./EditPost.vue?vue&type=template&id=761bd82a&scoped=true&"
import script from "./EditPost.vue?vue&type=script&lang=ts&"
export * from "./EditPost.vue?vue&type=script&lang=ts&"
import style0 from "./EditPost.vue?vue&type=style&index=0&id=761bd82a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761bd82a",
  null
  
)

component.options.__file = "EditPost.vue"
export default component.exports